import mergeWith from 'lodash.mergewith';
import cloneDeep from 'lodash.clonedeep';
import { baseTheme, UITheme, defaultFontStack } from '@harver/shared-ui';

export const defaultTheme: UITheme = {
    ...baseTheme,
    typography: {
        ...baseTheme.typography,
        h1: {
            ...baseTheme.typography.h1,
            letterSpacing: '0',
        },
        h2: {
            ...baseTheme.typography.h2,
            letterSpacing: '0',
        },
        h3: {
            ...baseTheme.typography.h3,
            letterSpacing: '0',
        },
        h4: {
            ...baseTheme.typography.h4,
            letterSpacing: '0',
        },
        h5: {
            ...baseTheme.typography.h5,
            letterSpacing: '0',
        },
    },
    header: {
        logo: 'https://public-media.harver.com/user-uploads/harver/harver_logo.svg',
    },
    // TODO: when do the shard-ui update we need to remove
    colors: {
        ...baseTheme.colors,
        primary: {
            ...baseTheme.colors.primary,
            '500': '#007DAA',
            '600': '#006488',
        },
    },
};

export interface ThemeConfig {
    colors?: UITheme['colors'];
    button?: UITheme['button'];
    typography?: {
        fontFamily?: string;
        headerFontFamily?: string;
    };
    backgroundColor?: string;
    header?: {
        backgroundColor?: string;
        textColor?: string;
        logo?: string;
        emailLogo?: string;
    };
}

const generateFontString = (fontStack: string[], firstFont: string): string => {
    const fonts = [...fontStack];
    fonts[0] = firstFont;

    return fonts.join(',');
};

export const parseTheme = (theme?: ThemeConfig): UITheme => {
    if (!theme) {
        return defaultTheme;
    }

    const brandedTheme = mergeWith(cloneDeep(defaultTheme), theme);

    if (theme.button?.fontFamily) {
        brandedTheme.button.fontFamily = generateFontString(defaultFontStack, theme.button.fontFamily);
    }

    if (theme.typography?.fontFamily) {
        brandedTheme.typography.fontFamily = generateFontString(defaultFontStack, theme.typography.fontFamily);
    }

    if (theme.typography?.headerFontFamily) {
        brandedTheme.typography.headerFontFamily = generateFontString(
            defaultFontStack,
            theme.typography.headerFontFamily,
        );
    }

    return brandedTheme;
};
